import {
    FETCH_LOAD_ALL_WASTE_REQUEST,
    FETCH_LOAD_ALL_WASTE_SUCCESS,
    FETCH_LOAD_ALL_WASTE_FALUIRE,
} from './loadAllWasteTypes'

const initialState = {
    loading: false,
    allWasteList: null,
    error: '',
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_LOAD_ALL_WASTE_REQUEST: return {
            ...state,
            loading: true,

        }

        case FETCH_LOAD_ALL_WASTE_SUCCESS: return {
            ...state,
            allWasteList: action.payload,
            error: '',
            loading: false,
        }

        case FETCH_LOAD_ALL_WASTE_FALUIRE: return {
            ...state,
            loading: false,
            allWasteList: null,
            error: action.payload,
        }

        default: return state

    }
}

export default reducer
